<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import MyPageResumeView from './resume/MyPageResumeView.vue';
import MyPageInterestedCorpView from './interestedCorp/MyPageInterestedCorpView.vue';
import MyPageInterestedJobPostingView from './interestedJobPosting/MyPageInterestedJobPostingView.vue';
import MyPageInterviewOffersView from './interviewOffers/MyPageInterviewOffersView.vue';
import SNB from '../../../../../layouts/nav/SNB.vue';

const route = useRoute();
const router = useRouter();
const tabRef = ref(null);

const tabOptions = [
  { label: '이력서 관리 및 입사지원 현황', value: 'resume' },
  { label: '관심기업', value: 'interested-corp' },
  { label: '관심공고', value: 'interested-job-posting' },
  { label: '받은 면접제안', value: 'interview-offers' }
];

const selectedTabValue = ref(tabOptions[0].value);

const onChangeTab = (tab) => {
  selectedTabValue.value = tab.value;
  router.push({ query: { tab: tab.value } });
};

onMounted(() => {
  const tabFromQuery = route.query.tab;
  if (tabFromQuery && tabOptions.some(opt => opt.value === tabFromQuery)) {
    selectedTabValue.value = tabFromQuery;

    if(tabRef.value) {
      tabRef.value.init(tabFromQuery);
    }
  }
});
</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNB class="snb" />
        <div class="content">
          <div class="sub-title">
            <h3>상시채용관 현황</h3>
          </div>
          <div class="tab-wrap">
            <KSATab
              ref="tabRef"
              :options="tabOptions"
              @change="onChangeTab"
              style="grid-template-columns: repeat(4, 1fr);"
            />
          </div>
          <div v-if="selectedTabValue === 'resume'">
            <MyPageResumeView />
          </div>
          <div v-else-if="selectedTabValue === 'interested-corp'">
            <MyPageInterestedCorpView />
          </div>
          <div v-else-if="selectedTabValue === 'interested-job-posting'">
            <MyPageInterestedJobPostingView />
          </div>
          <div v-else-if="selectedTabValue === 'interview-offers'">
            <MyPageInterviewOffersView />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tab-wrap {
  margin-bottom: 20px;
}
</style>
